// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#7c65b5"};